import baseModel from "models/base";
import { dashboardPageResolver } from "resolvers";
import { linkFor } from "utils";
import { getAccessToken } from "utils/oauth";
import dashboardService from "services/dashboard";

const dashboardModel = async (session) => {
  const baseData = {
    meta: { title: "Dashboard" },
    header: {
      title: { heading: "Dashboard", testId: "dashboard_title_header" },
    },
  };

  if (!session) {
    return { props: baseModel(baseData) };
  }

  const accessToken = await getAccessToken(session);
  const canGenerateKfiRequests = session.user?.canGenerateKfiRequests;
  const isAdminAdviser = session.user?.isAdmin;

  const base = baseModel({
    ...baseData,
    header: {
      title: {
        ...baseData.header.title,
        cta: canGenerateKfiRequests && {
          children: "New Client",
          href: linkFor("lendingCheck"),
          align: "right",
          icon: "AddCircle",
          testId: "dashboard_new_client_button",
        },
      },
    },
  });

  const [applications, applicationSummary, blogData] = await Promise.all([
    dashboardService.applications(accessToken),
    dashboardService.applicationSummary(accessToken),
    dashboardService.blogData(accessToken),
  ]);

  const errorMessages = [applications, applicationSummary]
    .filter((response) => response.error)
    .map((response) => response.error.message);

  const data = {
    ...base,
    applications,
    applicationSummary,
    blogData,
  };

  if (errorMessages.length > 0)
    return {
      props: { errors: errorMessages, base: baseModel(data) },
    };

  return {
    props: {
      ...dashboardPageResolver({
        canGenerateKfiRequests,
        data,
        isAdminAdviser,
      }),
      base: baseModel(data),
    },
  };
};

export default dashboardModel;
